import { FC } from 'react'
import CustomButton from '../../UI/CustomButton/CustomButton'
import { ServiceItem } from '../components/ServiceItem'
import styles from '../EditClaimCardMainInformation.module.css'
import { CommentTemplateType } from '../../../redux/actions/templatesAction'

interface HotelServicesSectionProps {
  values: any
  hotelServices: any[]
  commentTemplates: CommentTemplateType[]
  setFieldValue: (field: string, value: any) => void
  onOpenTemplateModal: (serviceId: number, serviceName: string, template?: CommentTemplateType) => void
  onDeleteTemplate: (templateId: number) => void
}

export const HotelServicesSection: FC<HotelServicesSectionProps> = ({
  values,
  hotelServices,
  commentTemplates,
  setFieldValue,
  onOpenTemplateModal,
  onDeleteTemplate,
}) => {
  const handleAddService = () => {
    setFieldValue('services', [...(values.services || []), { name: '', comment: '' }])
  }

  const handleServiceNameChange = (index: number, name: string) => {
    const updated = [...(values.services || [])]
    updated[index] = { ...updated[index], name }
    setFieldValue('services', updated)
  }

  const handleCommentChange = (index: number, comment: string) => {
    const updated = [...(values.services || [])]
    updated[index] = { ...updated[index], comment }
    setFieldValue('services', updated)
  }

  const handleTemplateChange = (index: number, template: CommentTemplateType) => {
    const updated = [...(values.services || [])]
    updated[index] = {
      ...updated[index],
      comment: template.comment,
      template: template,
    }
    setFieldValue('services', updated)
  }

  const handleDelete = (index: number) => {
    const updated = [...(values.services || [])]
    updated.splice(index, 1)
    setFieldValue('services', updated)
  }

  return (
    <div className={styles.sectionBlock}>
      <div className={styles.sectionTitle}>Службы отеля</div>
      <div className={styles.sectionContentSecond}>
        <div className={styles.buttonAddBlock}>
          <div className={styles.rightDateBlock}>
            <div className={styles.segmentInputBlock}>
              <CustomButton
                style={{ width: '100%' }}
                title='Добавить'
                type='button'
                onClick={handleAddService}
              />
            </div>
          </div>
        </div>

        {(values.services || []).map((service: any, index: number) => (
          <ServiceItem
            key={`service-${index}`}
            service={service}
            index={index}
            hotelServices={hotelServices}
            commentTemplates={commentTemplates}
            onServiceNameChange={handleServiceNameChange}
            onCommentChange={handleCommentChange}
            onTemplateChange={handleTemplateChange}
            onDelete={handleDelete}
            onOpenTemplateModal={onOpenTemplateModal}
            onDeleteTemplate={onDeleteTemplate}
          />
        ))}
      </div>
    </div>
  )
}
